<div class="body">

    <mat-icon class="icon" [ngClass]="{
        incoming: mail.incoming,
        outgoing: !mail.incoming
    }" matTooltip="{{mail.incoming? 'Eingehende E-Mail': 'Ausgehende E-Mail'}}">{{mail.incoming? 'arrow_right': 'arrow_left'}}</mat-icon>
    <div class="content">

        <div class="subject">
            {{mail.subject}}
        </div>
    
        <div class="transmitter">
            {{mail|mailTransmitter}}
        </div>
    
        <div class="received">
            {{mail.received|date:'dd.MM.yyyy HH:mm'}}
        </div>
        
    </div>

</div>